export default {
  modelName: 'admin',
  label: '後台管理員帳號管理',
  fields: {
    id: {
      type: 'text',
      label: 'ID',
      readonly: true,
    },
    email: {
      type: 'email',
      label: 'Email',
      rules: 'required|email',
      maxlength: 50,
      note: '新增後不可修改',
    },
    password: {
      type: 'password',
      label: '密碼',
      rules: 'required|min:6|nospace',
      updateNotNull: true,
      maxlength: 20,
    },
    name: {
      type: 'text',
      label: '管理者名稱',
      rules: 'required',
      maxlength: 30,
    },
    scopes: {
      type: 'multi-select',
      label: '權限',
      rules: 'required',
      defaultValue: 'admin',
      items: [
        {
          value: 'admin',
          text: 'admin',
        },
      ],
    },
    is_active: {
      type: 'switch',
      label: '啟用/停用',
      activeText: '啟用',
      inactiveText: '停用',
      defaultValue: true,
    },
    avatar: {
      type: 'image',
      label: '頭像',
      uploadUrl: '/user/avatar/',
    },
    roles: {
      type: 'hasMany',
      label: '角色',
      textKey: 'name',
      modelName: 'user_role',
    },
    organizations: {
      type: 'hasMany',
      label: '所屬企業',
      textKey: 'name',
      modelName: 'organization',
    },
    factories: {
      type: 'hasMany',
      label: '所屬工廠',
      textKey: 'name',
      modelName: 'factory',
    },
    sequence: {
      type: 'text',
      label: '排序',
      maxlength: 10,
    },
    updated_at: {
      type: 'datetime',
      label: '最後更新時間',
      readonly: true,
    },
    updated_admin: {
      type: 'belongsTo',
      label: '最後更新人',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
    created_at: {
      type: 'datetime',
      label: '建立時間',
      readonly: true,
    },
    created_admin: {
      type: 'belongsTo',
      label: '建立者',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
    // updated_info: {
    //   type: "custom",
    //   label: "上次修改時間",
    //   getValue: (item) => {
    //     let _value = item.updated_at;
    //     if (item.updated_admin) {
    //       _value += `  ${item.updated_admin}`;
    //     }
    //     return _value;
    //   },
    // },
  },
};
